import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-success-error-actions-renderer',
    template: `
        <div class="flex align-items-center list-user-action">
            <ng-container *ngIf="issuccess === true" >
                <i class="bx bx-check-circle text-success me-1" title="Success" ></i>
            </ng-container>
            <ng-container *ngIf="issuccess === false">
                <i class="bx bx-error-circle text-danger me-1" (click)="invokeParentErrorMethod()" title="Error"></i>
            </ng-container>
        </div>
    `,
    styles: [
        `
                .list-user-action {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
            }
            .list-user-action i {
                font-size: 1.2rem;
            }

        `,
    ],
})
export class IRNStatusRenderer implements ICellRendererAngularComp {
    public params!: ICellRendererParams;
    public issuccess: boolean | null = null;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.issuccess = this.params.data.issuccess??this.params.data.isvalid;
    }

    public invokeParentErrorMethod() {
        this.params.node.data.srno = this.params.node.rowIndex + 1;
        this.params.context.componentParent.errorAction(this.params.node.data);
    }

    refresh(): boolean {
        return false;
    }
}
